import DefaultTemplate from './DefaultTemplate';
import FlooringOptionSingleSelectTemplate from './FlooringOptionSingleSelectTemplate';
import Flooring from './RoomTemplate';
import CarpetPadTemplate from './CarpetPadTemplate';
import SuperSkuTemplate from './SuperSkuTemplate/SuperSkuContainer';
import Tiles from './Tiles';
import ColorSwatchesTemplate from './ColorSwatches/ColorSwatchesContainer';
import Hidden from './Hidden';

const templates = {
  Default: DefaultTemplate,
  FlooringOption: FlooringOptionSingleSelectTemplate,
  FlooringOptionSingleSelect: FlooringOptionSingleSelectTemplate,
  Room: Flooring,
  InfoCardwithBanner: CarpetPadTemplate,
  SuperSku: SuperSkuTemplate,
  Tiles,
  ColorSwatches: ColorSwatchesTemplate,
  Hidden
};

export default templates;
